import { render, staticRenderFns } from "./GroupFilter.component.vue?vue&type=template&id=3ac1a00e&scoped=true&lang=pug"
import script from "./GroupFilter.component.vue?vue&type=script&lang=ts"
export * from "./GroupFilter.component.vue?vue&type=script&lang=ts"
import style0 from "./GroupFilter.component.vue?vue&type=style&index=0&id=3ac1a00e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac1a00e",
  null
  
)

export default component.exports